import { Routes } from "@angular/router";
import { NotFoundComponent } from "../site-pages/errors/not-found/feature/not-found.component";

export const errorRoutes: Routes = [
    { path: '404', component: NotFoundComponent},
    { path: '**', component: NotFoundComponent },
]
